import { statusMeta } from "../lib/format";

export default function StatusBadge({ status, testid }) {
  const m = statusMeta(status);
  return (
    <span
      className={`pxos-badge ${m.cls}`}
      data-testid={testid || "status-badge"}
      data-status={status}
    >
      {m.label}
    </span>
  );
}
